import React from 'react';
import { Section } from './Section';
export function SocialPhrases() {
  const phrases = ['Diste vida. Ahora mereces recuperar la tuya.', 'Ser buena mamá no significa olvidarte de ti misma.', 'La mejor mamá que puedes ser es una mamá que también se cuida a sí misma.', 'Tu mejor versión como mamá empieza cuando te recuperas como mujer.'];
  return <Section className="bg-sage/5 py-16" data-id="element-174">
      <div className="max-w-5xl mx-auto" data-id="element-175">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-176">
          {phrases.map((phrase, index) => <div key={index} className="text-center p-6" data-id="element-177">
              <p className="font-script text-3xl md:text-4xl text-sage leading-relaxed" data-id="element-178">
                "{phrase}"
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}